<template>
  <v-sheet height="100%" color="transparent">
    <v-container class="mt-4 py-7" v-if="!loading">
      <div class="white--text text-center articles-title">Blog</div>

      <div class="article-list" v-if="totalItems">
        <div class="article-grid">
          <article-card
            v-for="({ title, img, to }, index) in items"
            :key="index"
            :title="title"
            :img="img"
            :to="to"
          ></article-card>
        </div>

        <v-pagination
          v-model="page"
          :length="pagesLength"
          :total-visible="9"
          v-if="pagesLength > 1"
        ></v-pagination>
      </div>
      <v-alert v-else name="warn" type="warning" class="mt-6">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>
    </v-container>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </v-sheet>
</template>

<script>
import ArticleCard from "@/components/cards/Article.vue";
import { formatToURL } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    items: [],
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest("articles")
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, img, title }) => ({
              img: this.files + img,
              title,
              to: `blog/${formatToURL(title)}-${id}`,
            }));
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    ArticleCard,
  },
};
</script>

<style scoped>
.articles-title {
  font-size: 37px;
  font-weight: 400;
  line-height: 55px;
}

.article-list {
  display: grid;
  gap: 30px;
  margin-top: 30px;
}

.article-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 30px 16px;
}

@media screen and (max-width: 960px) {
  .article-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .articles-title {
    font-size: 22px;
    line-height: 26px;
  }

  .article-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
